"use client";

import { useEffect, useState } from "react";

export function DemoPreview() {
  const [demoView, setDemoView] = useState("home");

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === "demo-nav-change" && event.data?.view) {
        setDemoView(event.data.view);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  // Map view to URL path
  const urlPath = demoView;

  return (
    <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl shadow-2xl overflow-hidden">
      {/* Browser Chrome */}
      <div className="border-b border-gray-200 px-3 sm:px-6 py-2 sm:py-4 bg-gray-50">
        <div className="flex items-center gap-1.5 sm:gap-2">
          <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-gray-300"></div>
          <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-gray-300"></div>
          <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-gray-300"></div>
          <div className="flex-1 ml-2 sm:ml-4 px-2 sm:px-4 py-1 sm:py-1.5 bg-white rounded-md text-xs sm:text-sm text-gray-500 border border-gray-200 truncate">
            trycommons.com/@yourteam/{urlPath}
          </div>
        </div>
      </div>

      {/* Embedded Demo */}
      <iframe
        src="/demo/feed"
        className="w-full h-[500px] sm:h-[700px] md:h-[800px] bg-gray-50 border-0"
        title="Commons Demo Home"
        scrolling="no"
      />
    </div>
  );
}
